import Skeleton from './Skeleton'
import './Skeleton.css'

/**
 * Skeleton loading state for the Carriers table.
 * Matches the exact structure of the carriers table for seamless transition.
 *
 * @param {number} rows - Number of skeleton rows to display (default: 5)
 */
function CarrierTableSkeleton({ rows = 5 }) {
  return (
    <div className="table-container">
      <table className="carriers-table">
        <thead>
          <tr>
            <th>Icon</th>
            <th>Carrier Name</th>
            <th>Freight Type</th>
            <th>Contact Type</th>
            <th>Primary Contact</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, index) => (
            <tr key={index} className="skeleton-row">
              {/* Icon cell - 2rem circle matching carrier-icon-large */}
              <td className="icon-cell">
                <Skeleton variant="circular" width="2rem" height="2rem" />
              </td>
              {/* Carrier name - text with strong font */}
              <td className="name-cell">
                <Skeleton variant="text" width="140px" height="1rem" />
              </td>
              {/* Freight type - badge style */}
              <td>
                <Skeleton variant="rectangular" width="65px" height="24px" />
              </td>
              {/* Contact type - icon + label */}
              <td>
                <Skeleton variant="text" width="80px" height="0.875rem" />
              </td>
              {/* Primary contact - email/phone/url */}
              <td className="contact-cell">
                <Skeleton variant="text" width="180px" height="0.875rem" />
              </td>
              {/* Actions - Details button */}
              <td className="actions-cell">
                <Skeleton variant="rectangular" width="90px" height="34px" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default CarrierTableSkeleton
